import { render, staticRenderFns } from "./formEdit.vue?vue&type=template&id=a130f2fc&scoped=true"
import script from "./formEdit.vue?vue&type=script&lang=js"
export * from "./formEdit.vue?vue&type=script&lang=js"
import style0 from "./formEdit.vue?vue&type=style&index=0&id=a130f2fc&prod&lang=css"
import style1 from "./formEdit.vue?vue&type=style&index=1&id=a130f2fc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a130f2fc",
  null
  
)

export default component.exports